export const defaultDropDownStatus = {};

export const cancellationReasonOptions = [
  { label: "Spausdinimo klaida", value: 1},
  { label: "Nutraukta komercinė operacija", value: 2},
  { label: "Sudubliuoti dokumentai", value: 3},
  { label: "Išsiuntimo dieną gabenimas nepradėtas", value: 4},
  { label: "Krovinio gražinimas siuntėjui", value: 5},
  { label: "Kita", value: 6},
];